import { Column } from "../objects/column";
import { DestinationZoneFormType } from "../objects/destinationZoneForm";
import { DestinationZoneListConfiguration, DestinationZoneListFiltersCriteria } from "../objects/destinationZoneTypeList";
import { DestinationZoneListCriteria } from "../objects/destinationZoneTypeList";

export const EMPTY_DESTINATION_ZONE: DestinationZoneFormType = {
    name: '',
    localization: [],
    destinations: [],
    name_locales: {}
};

export const EMPTY_DESTINATION_ZONE_FILTERS: DestinationZoneListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION"
};

export const EMPTY_DESTINATION_ZONE_LIST_CRITERIA: DestinationZoneListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_DESTINATION_ZONE_FILTERS,
    search: '',
};


export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'destinations',
    field_name: 'DESTINATIONS',
    checked: true,
    order_by: 'destinations',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false
}];

export const EMPTY_DESTINATION_ZONE_LIST_CONFIGURATION: DestinationZoneListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const DESTINATION_ZONE_MODULE = 'DESTINATION_ZONE';
